module.exports = __webpack_public_path__ + "static/media/filter.f49ac713.svg";